import React, { useState, useEffect } from 'react';
import { Chart } from "react-google-charts";
import classnames from 'classnames';
import moment from 'moment';
import utils from '../../../lib/utils';

import './index.scss';

const colors = ['#0B7CC2'];
const colors2 = ['#0B7CC2'];
const colors3 = ['#0B7CC2'];

const labels = {
    BOOKINGS: 'Bookings',
    CONVERSION_RATE: 'Conversion Rate',
    ENGAGEMENT_RATE: 'Engagement Rate',
    SUBMISSIONS: 'Submissions',
};

const numberWithCommas = function (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const Trends = (props) => {
    const [isStacked, setIsStacked] = useState(false);
    const [processedData, setProcessedData] = useState([]);
    const [daterangeMap, setDaterangeMap] = useState({});

    useEffect(() => {
        setProcessedData(processWithFilter(props));
    }, [props]);

    const getColors = (processed_data) => {
        return (processed_data.length === 12 || processed_data.length === 21 || processed_data.length === 18) ? colors : (isStacked) ? colors2 : colors3;
    }

    const roundTheDecimal = (value) => {
        const { activeTrend } = props;
        if (activeTrend === 'TIME_SAVED') {
            const in_hrs = value / 60;
            return Math.round(in_hrs * 100) / 100;
        } else {
            return Math.round(Math.round(value * 100) / 100);
        }
    }

    const getSuffix = () => {
        const { activeTrend } = props;
        if (activeTrend === 'ENGAGEMENT_RATE' || activeTrend === 'CONVERSION_RATE') {
            return '%';
        } else {
            return '';
        }
    }

    const getHtmlTooltip = (key, label, value, location, showlocation) => {
        const { brand_ids, studioId } = location;
        let filterd_label = location.business_name;
        if (brand_ids && studioId && brand_ids.includes(studioId)) {
            filterd_label = 'All accounts avg';
        }
        const locationmarkup = (showlocation === false) ? '' : '<div style="padding:0 0 15px 0;font-size:13px;text-transform: uppercase;font-weight:800;white-space: nowrap;">' + filterd_label + '</div>';
        return '<div style="padding:15px 15px 15px 15px;background: rgba(0,0,0,0.6); color: #FFFFFF;">' +
            '<div style="padding:0 0 15px 0;font-size:13px;font-weight:800;">' + (daterangeMap[key] || key) + '</div>' + locationmarkup +
            '<div style="font-size:13px;">' + label + ':  <span style="font-weight:800;">' + numberWithCommas(value) + getSuffix() + '</span></div>' +
            '</div>';
    }

    const processWithFilter = (props) => {
        const { trends = {}, activeTrend } = props;
        const { trend_type_metrics = {} } = trends;
        const data = trend_type_metrics[activeTrend] || [];
        let formatted_metrics_data = [];

        formatted_metrics_data = data.map((key, index) => {
            return [
                moment(data[index].year_month, "YYYY-MM").format("MMM 'YY"),
                roundTheDecimal(data[index].value),
                getHtmlTooltip(moment(data[index].year_month, "YYYY-MM").format("MMM YYYY"), labels[activeTrend], roundTheDecimal(data[index].value), {}, false)
            ];
        });
        formatted_metrics_data.reverse();
        formatted_metrics_data.unshift(['Range', 'Total Submissions', { role: "tooltip", type: "string", p: { html: true } }]);

        console.log('formatted_metrics_data', formatted_metrics_data);
        return formatted_metrics_data;
    };

    return (
        <div className="stats-container">
            <div className="stats-container__body">
                {processedData.length>1 &&
                    <div className="graph" id="statgraph">
                        <Chart
                            width="100%"
                            height="400px"
                            chartType="ColumnChart"
                            loader={<div>Loading Chart</div>}
                            data={processedData}
                            options={{
                                chartArea: {
                                    width: '85%',
                                    left: 80,
                                    right: 80,
                                    top: 60,
                                    bottom: 80,
                                    backgroundColor: {
                                        stroke: '#F9FAFC',
                                        strokeWidth: 3,
                                        fill: '#F9FAFC'
                                    }
                                },
                                colors: getColors(processedData),
                                isStacked: isStacked,
                                legend: { position: 'none' },
                                tooltip: { isHtml: true },
                                baselineColor: '#D3E0E7',
                                hAxis: {
                                    baseline: 0,
                                    viewWindow: { min: 0 },
                                    textStyle: {
                                        fontSize: 11,
                                        fontName: 'Montserrat',
                                        color: '#96ADB9',
                                        fontWeight: 600,
                                        bold: true,
                                        italic: false
                                    },
                                    gridlines: {
                                        color: '#D3E0E7',
                                        count: 6
                                    },
                                    minorGridlines: {
                                        color: 'transparent',
                                    },
                                },
                                vAxis: {
                                    baseline: 0,
                                    viewWindow: { min: 0, ...((props.activeTrend === 'CONVERSION_RATE' || props.activeTrend === 'ENGAGEMENT_RATE') && { max: 100 })},
                                    textStyle: {
                                        fontSize: 13.23,
                                        fontName: 'Montserrat',
                                        color: '#96ADB9',
                                        fontWeight: 600,
                                        bold: true,
                                        italic: false
                                    },
                                    gridlines: { color: '#D3E0E7', count: 5 },
                                    minorGridlines: {
                                        color: 'transparent',
                                    }
                                },
                                annotations: {
                                    stem: {
                                        color: 'transparent',
                                        length: 120
                                    }
                                },
                            }}
                        />
                    </div>}
            </div>
        </div>
    );
}

export default Trends;
